module.exports = __webpack_public_path__ + "static/media/home_banner_ad_background.6f37fe35.png";